<template>
  <div class="payment-regulation-view">
    <PaymentRegulation />
  </div>
</template>

<script>
import PaymentRegulation from '@/components/payment-regulation/PaymentRegulation.vue'

export default {
  name: 'PaymentRegulationView',

  components: {
    PaymentRegulation
  },

  beforeRouteLeave(to, from, next) {
    // Prevent leaving unless payment has been resolved
    const user = localStorage.getItem('user')
    if (user && user !== 'undefined') {
      const parsed = JSON.parse(user)
      if (parsed && parsed._premium && parsed._premium.needAddPaymentMethod) {
        return next(false)
      }
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.payment-regulation-view {
  min-height: 100vh;
  background: #fbfafc;
}
</style>
